import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typography from "../Typography/Typography";
import { useEffect, useState } from "react";
import { useGetChangeAllActionsType } from "../../hooks/useCrm";
const initValue = {
  IdChange: null,
};
export const ChangeAllActionsTypeModal = ({ handleClose, show, dates }) => {
  const [form, setForm] = useState(initValue);
  const { mutateAsync: changeDates } = useGetChangeAllActionsType();
  useEffect(() => {
    setForm({
      IdChange: dates,
    });
  }, [dates]);

  const handleChange = async () => {
    await changeDates(form).then(() => setForm(initValue));
  };
  return (
    <BootstrapModal
      modaltitle="تغییر کلی فعالیت ها به فرصت ها"
      handleClose={handleClose}
      show={show}
      //   moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <>
        <Typography>
          آیا از تغییر کلی فعالیت ها به فرصت ها مطمئن هستید؟
        </Typography>
        <div className="d-flex w-100 justify-content-end mt-4">
          <Button
            small="70px"
            className="p-1 mx-2"
            bgColor="#50cd89"
            color="#fff"
            onclick={() => {
              handleChange();
              handleClose();
            }}
          >
            بله
          </Button>
          <Button
            small="70px"
            className="p-1"
            bgColor="#f1416c"
            color="#fff"
            onclick={handleClose}
          >
            خیر
          </Button>
        </div>
      </>
    </BootstrapModal>
  );
};
